import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { CRM_ENRICHMENT_CONTENT_ID } from "../../constants";
import type { CrmProvider } from "../../types/types";
import { ConfirmationModal } from "app/pages/sales-intelligence/common-components/modals/ConfirmationModal/ConfirmationModal";
import {
    StyledConfirmationModalButtonsContainer,
    StyledConfirmationModalLabel,
} from "app/pages/sales-intelligence/common-components/modals/ConfirmationModal/styles";

type CrmEnrichmentJobRemoveModalProps = {
    isOpened: boolean;
    isSubmitLoading: boolean;
    jobName: string;
    crmProvider: CrmProvider;
    onClose: () => void;
    onRemoveJob: () => void;
};

const CrmEnrichmentJobRemoveModal = ({
    isOpened,
    onClose,
    onRemoveJob,
    isSubmitLoading,
    jobName,
    crmProvider,
}: CrmEnrichmentJobRemoveModalProps) => {
    const contentId = CRM_ENRICHMENT_CONTENT_ID[crmProvider];

    return (
        <ConfirmationModal
            isOpened={isOpened}
            titleKey={`si.crm-enrichment.${contentId}.remove-modal.header`}
            dataAutomation={`${contentId}-enrichment-job-remove-modal`}
        >
            <I18n
                element={StyledConfirmationModalLabel}
                htmlFor={`${contentId}-job-Remove-input`}
                translatable={{
                    key: `si.crm-enrichment.${contentId}.remove-modal.text.named`,
                    replacements: { jobName },
                }}
            />
            <StyledConfirmationModalButtonsContainer>
                <Button
                    type="flatDark"
                    onClick={onClose}
                >
                    {translate("si.common.button.cancel")}
                </Button>
                <Button
                    type="warning"
                    isLoading={isSubmitLoading}
                    onClick={onRemoveJob}
                >
                    {translate("si.common.button.delete")}
                </Button>
            </StyledConfirmationModalButtonsContainer>
        </ConfirmationModal>
    );
};

export default CrmEnrichmentJobRemoveModal;
